import React, {useState} from "react";
import {selfcareChangePassword} from "../../../util/request";
import IconButton from "../IconButton";
import LoaderSpinner from "../../loaders/LoaderSpinner";
import IconEyeClosed from "../../icons/IconEyeClosed.tsx";
import IconEye from "../../icons/IconEye.tsx";

export default function ChangePassword() {
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)
    const [newPassword, setNewPassword] = useState<string>("");
    const [newPasswordRepeat, setNewPasswordRepeat] = useState<string>("");
    const [showForm, setShowForm] = useState<boolean>(true);
    const [passwordPreview, setPasswordPreview] = useState<boolean>(false);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (newPassword !== newPasswordRepeat) {
            setErrorMessage("De to adgangskoder er ikke ens");
            return
        }

        if(newPassword.length < 6) {
            setErrorMessage("Adgangskoden skal være på mindst 6 tegn");
            return
        }

        setLoading(true);

        selfcareChangePassword(newPassword).then(r => {
            if (r.code !== 200) {
                setErrorMessage(r.response.error_message as string)
                return
            }
            setSuccessMessage('Din nye adgangskode blev gemt')
            setShowForm(false)

        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen')
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleNewPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPassword(e.target.value)

        if (errorMessage !== "") {
            setErrorMessage("");
        }
    }
    const handleNewPasswordRepeat = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPasswordRepeat(e.target.value)

        if (errorMessage !== "") {
            setErrorMessage("");
        }
    }

    return (
        <form className="selfcare-account-form visible" onSubmit={handleSubmit}>
            {showForm && (
                <>
                    <p className="input-with-button">
                        <input
                            type={passwordPreview ? "text" : "password"}
                            placeholder="Ny adgangskode"
                            onChange={handleNewPassword}
                            required
                        />
                        <span className="button-container">
                            <IconButton
                                className="icon-button"
                                component={passwordPreview ? IconEyeClosed : IconEye}
                                onClick={() => setPasswordPreview(!passwordPreview)}
                            />
                        </span>
                    </p>
                    <p className="input-with-button">
                        <input
                            type={passwordPreview ? "text" : "password"}
                            placeholder="Gentag ny adgangskode"
                            onChange={handleNewPasswordRepeat}
                            required
                        />
                        <span className="button-container">
                            <IconButton
                                className="icon-button"
                                component={passwordPreview ? IconEyeClosed : IconEye}
                                onClick={() => setPasswordPreview(!passwordPreview)}
                            />
                        </span>
                    </p>

                    {errorMessage && <p className="selfcare-message-error">{errorMessage}</p>}

                    {loading ? <LoaderSpinner/> :
                        <p className="submit-button-block">
                            <label id="submit-form-button" className="button teal">
                                <input disabled={loading} className="continue-button-submit" type="submit"/>
                                    <span className="text">Skift adgangskode</span>
                            </label>
                        </p>
                    }
                </>
                )}

            {successMessage && <p className="selfcare-message-success">{successMessage}</p>}
        </form>

    )
}
